import styled from "styled-components";

export const FileUploaderContainer = styled.div`
  && {
    width: 100%;
    text-transform: capitalize;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid lightgray;
    border-radius: 3px;
    padding: 3px;
    margin-left: 10px;

    .file-input {
      display: none;
      visibility: hidden;
    }

    .file-name {
      margin: auto;
      padding: 5px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;
